var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy } from '@angular/core';
import { SocketService } from '../shared/services/socket.service';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { GameComponent } from '../game/game.component';
import { MessageType } from '../shared/model/message-type';
import { DiceMessageType } from '../shared/model/dice-message';
import { LiarsDiceGameState } from '../shared/model/liars-dice-game';
import { GameStatus } from '../shared/model/game-status';
import { WindowsService } from '../shared/services/windows.service';
var LiarsDiceComponent = /** @class */ (function (_super) {
    __extends(LiarsDiceComponent, _super);
    function LiarsDiceComponent(socketService, cookieService, router, resolver, windowService) {
        var _this = _super.call(this, socketService, cookieService, router, resolver) || this;
        _this.windowService = windowService;
        _this.defaultDice = [1, 2, 3, 4, 5, 6];
        _this.dice = [1, 2, 3, 4, 5];
        _this.spinCount = 0;
        _this.maxSpins = 10;
        _this.startingScore = 5;
        _this.canChallengeExact = false;
        _this.hasSpun = false;
        _this.hasSubmission = false;
        _this.submitMode = false;
        _this.canChallenge = false;
        _this.diceGuess = {
            count: 1,
            die: 1
        };
        _this.hostDice = {
            user: '',
            count: 0,
            die: 0
        };
        return _this;
    }
    LiarsDiceComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.spinInterval) {
            this.windowService.clearInterval(this.spinInterval);
        }
    };
    LiarsDiceComponent.prototype.messageHandler = function (message) {
        if (message.action === MessageType.Prompt || message.action === MessageType.Host) {
            var gameState = message.content;
            if (Object.keys(gameState).length > 0) {
                this.setGameState(gameState);
            }
        }
    };
    LiarsDiceComponent.prototype.setGameState = function (gameState) {
        if (gameState.eliminated.indexOf(this.user.name) > -1 ||
            gameState.status === GameStatus.Complete) {
            this.router.navigate(['/login']);
        }
        else if (gameState.dice[this.user.name]) {
            this.dice = gameState.dice[this.user.name];
            this.turnUserName = gameState.submitter;
            this.canChallengeExact = Object.keys(gameState.dice).length === 2;
            if (gameState.shouldRespin) {
                this.spin();
            }
            this.hasSubmission = Object.keys(gameState.currentSubmission).length > 0;
            this.canChallenge =
                this.user.name !== gameState.currentSubmission.user && this.hasSubmission;
            this.submitMode = this.user.name === gameState.submitter;
            this.hostDice = gameState.currentSubmission;
        }
    };
    LiarsDiceComponent.prototype.spin = function () {
        var _this = this;
        this.spinInterval = this.windowService.setInterval(function () {
            _this.spinHandler();
        }, 200);
    };
    LiarsDiceComponent.prototype.spinHandler = function () {
        for (var i = 0; i < this.dice.length; i++) {
            this.dice[i] = this.getRandomDie();
        }
        this.spinCount++;
        if (this.spinCount >= this.maxSpins) {
            this.spinCount = 0;
            this.stopSpinning();
        }
    };
    LiarsDiceComponent.prototype.sendDice = function () {
        var message = {
            user: this.user.name,
            dice: this.dice,
            type: DiceMessageType.Dice
        };
        this.socketService.send({
            from: this.user,
            content: message,
            action: MessageType.Response,
            gameId: this.gameId
        });
    };
    LiarsDiceComponent.prototype.sendGuess = function () {
        if (this.isDiceSubmissionValid()) {
            this.submitMode = false;
            this.canChallenge = false;
            var message = {
                user: this.user.name,
                dice: this.dice,
                guess: this.diceGuess,
                type: DiceMessageType.Guess
            };
            this.socketService.send({
                from: this.user,
                content: message,
                action: MessageType.Response,
                gameId: this.gameId
            });
            this.diceGuess = {
                count: 1,
                die: 1
            };
        }
        else {
            this.windowService.alert("Dice submission is not valid:\n\n" +
                "The quantity of dice can never be lowered, however if you raise the quantity, the dice face can be lowered.\n\n" +
                "Remember: 1's are wild and count in the dice total!");
        }
    };
    LiarsDiceComponent.prototype.sendChallenge = function (exacto) {
        if (exacto === void 0) { exacto = false; }
        this.submitMode = false;
        this.canChallenge = false;
        var message = {
            user: this.user.name,
            dice: this.dice,
            guess: this.diceGuess,
            exacto: exacto,
            type: DiceMessageType.Challenge
        };
        this.socketService.send({
            action: MessageType.Response,
            content: message,
            from: this.user,
            gameId: this.gameId
        });
    };
    LiarsDiceComponent.prototype.stopSpinning = function () {
        if (this.spinInterval) {
            this.windowService.clearInterval(this.spinInterval);
        }
        this.hasSpun = true;
        this.sendDice();
    };
    LiarsDiceComponent.prototype.getRandomDie = function () {
        return Math.round(Math.random() * 5) + 1;
    };
    LiarsDiceComponent.prototype.selectDie = function (die) {
        this.diceGuess.die = die;
    };
    LiarsDiceComponent.prototype.isDiceSubmissionValid = function () {
        if (this.diceGuess.count === this.hostDice.count) {
            return this.diceGuess.die > this.hostDice.die;
        }
        else if (this.diceGuess.count < this.hostDice.count) {
            return false;
        }
        return true;
    };
    return LiarsDiceComponent;
}(GameComponent));
export { LiarsDiceComponent };
